import * as actions from "../actionTypes"

// is stories in edit mode?
const initialState = {
    value: false,
}

export default function storyEdit(state = initialState, action) {
    switch (action.type) {
        case actions.SET_EDIT_MODE: {
            return {
                ...state,
                value: action.payload.value,
            }
        }

        default:
            return state
    }
}
